import React from 'react';
import CTAButton from '../components/CTAButton';
const AboutPage = () => {
  return <div className="bg-cream" data-id="element-161">
      {/* Hero Section */}
      <section className="bg-beige py-16" data-id="element-162">
        <div className="container mx-auto px-4 text-center" data-id="element-163">
          <h1 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-164">
            About Jemi Baby Care
          </h1>
          <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-165">
            Supporting African moms through care, education, and safe solutions
            for their babies.
          </p>
        </div>
      </section>
      {/* Founder's Story */}
      <section className="py-16" data-id="element-166">
        <div className="container mx-auto px-4" data-id="element-167">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-168">
            <div className="md:w-1/2" data-id="element-169">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nsEzfvmzRnahWRCFNqTxiT/Dr._Sophia_Igbineweka.png" alt="Dr. Sophia Igbineweka - Founder" className="rounded-lg shadow-lg w-full h-auto" data-id="element-170" />
            </div>
            <div className="md:w-1/2" data-id="element-171">
              <h2 className="text-2xl font-bold text-brown mb-4" data-id="element-172">
                Our Founder's Story
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-173">
                Jemi Baby Care was born from a mother's personal journey and
                challenges. When our founder had her first child, she struggled
                to find reliable information about baby nutrition that was
                relevant to the African context.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-174">
                After extensive research, consulting with pediatricians, and
                experimenting with recipes in her own kitchen, she created a
                system that worked for her baby. Friends and family began asking
                for her advice, and she realized there was a gap that needed to
                be filled.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-175">
                Today, Jemi Baby Care is dedicated to supporting mothers across
                Africa with practical, trustworthy resources that make the
                journey of motherhood a little easier and a lot more confident.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Mission & Values */}
      <section className="py-16 bg-white" data-id="element-176">
        <div className="container mx-auto px-4" data-id="element-177">
          <div className="text-center mb-12" data-id="element-178">
            <h2 className="text-2xl md:text-3xl font-bold text-brown mb-4" data-id="element-179">
              Our Mission
            </h2>
            <p className="text-gray-700 max-w-3xl mx-auto" data-id="element-180">
              To support African moms through care, education, and safe
              solutions, ensuring every baby gets the best start in life through
              proper nutrition and care.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-181">
            <div className="bg-cream p-8 rounded-lg shadow-md text-center" data-id="element-182">
              <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-183">
                <span className="text-brown text-2xl" data-id="element-184">❤️</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-185">Care</h3>
              <p className="text-gray-700" data-id="element-186">
                We put the wellbeing of mothers and babies at the heart of
                everything we do.
              </p>
            </div>
            <div className="bg-cream p-8 rounded-lg shadow-md text-center" data-id="element-187">
              <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-188">
                <span className="text-brown text-2xl" data-id="element-189">📚</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-190">Education</h3>
              <p className="text-gray-700" data-id="element-191">
                We believe in empowering mothers with knowledge to make
                confident decisions.
              </p>
            </div>
            <div className="bg-cream p-8 rounded-lg shadow-md text-center" data-id="element-192">
              <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-193">
                <span className="text-brown text-2xl" data-id="element-194">👨‍👩‍👧</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-195">Community</h3>
              <p className="text-gray-700" data-id="element-196">
                We foster a supportive network where mothers can share, learn,
                and grow together.
              </p>
            </div>
            <div className="bg-cream p-8 rounded-lg shadow-md text-center" data-id="element-197">
              <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-198">
                <span className="text-brown text-2xl" data-id="element-199">🤝</span>
              </div>
              <h3 className="text-xl font-bold text-brown mb-2" data-id="element-200">Trust</h3>
              <p className="text-gray-700" data-id="element-201">
                We are committed to providing reliable, expert-backed
                information and products.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-beige" data-id="element-202">
        <div className="container mx-auto px-4 text-center" data-id="element-203">
          <h2 className="text-2xl md:text-3xl font-bold text-brown mb-4" data-id="element-204">
            Join Our Community of Mothers
          </h2>
          <p className="text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-205">
            Connect with other moms, access exclusive resources, and get support
            on your motherhood journey.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-206">
            <CTAButton text="Shop Our Products" link="/shop" data-id="element-207" />
            <CTAButton text="Join Our Community" link="/community" variant="secondary" data-id="element-208" />
          </div>
        </div>
      </section>
    </div>;
};
export default AboutPage;